<template>
  <div v-if="isShow" class="dialog">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "base-dialog",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },

  updated() {
    if (this.isShow) document.body.classList.add("overflow-hidden");
    else document.body.classList.remove("overflow-hidden");
  },
};
</script>
